import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './Services/authentication/auth.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./Pages/home/home.module').then(m => m.HomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    children: [
      { path: '', loadChildren: () => import('./Pages/login/login.module').then(m => m.LoginPageModule) },
      { path: ':empresa', loadChildren: () => import('./Pages/login/login.module').then(m => m.LoginPageModule) }
    ]
  },
  {
    path: 'login/:empresa',
    loadChildren: () => import('./Pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'andamentoOPs',
    loadChildren: () => import('./Pages/home/Tabs/andamentoOPs/andamentoOPs.module').then(m => m.AndamentoOPsPageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
